module.exports = __webpack_public_path__ + "static/media/mini-config.db0d0b10.svg";